import { VacationPeriod, AlternativeSlot, Location } from '../types';

export const isOnVacation = (date: Date, locationId: number, vacationPeriods: VacationPeriod[]): boolean => {
  const dateStr = `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
  
  return vacationPeriods.some(vacation => 
    vacation.location_id === locationId &&
    vacation.isActive &&
    dateStr >= vacation.startDate &&
    dateStr <= vacation.endDate
  );
};

export const getVacationPeriod = (date: Date, locationId: number, vacationPeriods: VacationPeriod[]): VacationPeriod | null => {
  const dateStr = `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}`;
  
  return vacationPeriods.find(vacation => 
    vacation.location_id === locationId &&
    vacation.isActive &&
    dateStr >= vacation.startDate &&
    dateStr <= vacation.endDate
  ) || null;
};

export const generateAlternativeSlots = (
  originalDate: Date, 
  locationId: number, 
  locations: Location[], 
  vacationPeriods: VacationPeriod[]
): AlternativeSlot[] => {
  const alternatives: AlternativeSlot[] = [];
  const location = locations.find(l => l.id === locationId);
  
  if (!location) return alternatives;

  // Generate next 14 days as alternatives
  for (let i = 1; i <= 14; i++) {
    const alternativeDate = new Date(originalDate);
    alternativeDate.setDate(alternativeDate.getDate() + i);
    
    // Skip if location is on vacation
    if (isOnVacation(alternativeDate, locationId, vacationPeriods)) continue;
    
    // Skip if not in openDays
    const dayOfWeek = (alternativeDate.getDay() + 6) % 7; // Convert to Monday=0
    if (!location.openDays?.includes(dayOfWeek)) continue;

    // Generate time slots for this day
    const timeSlots = generateTimeSlots(location);
    
    timeSlots.slice(0, 3).forEach(time => { // Only first 3 slots per day
      alternatives.push({
        date: alternativeDate.toISOString().split('T')[0],
        time,
        location_id: locationId,
        available: true
      });
    });

    if (alternatives.length >= 10) break; // Limit to 10 alternatives
  }

  return alternatives;
};

const generateTimeSlots = (location: Location): string[] => {
  const slots: string[] = [];
  const [startHour, startMin] = (location.openTimes?.start || '09:00').split(':').map(Number);
  const [endHour, endMin] = (location.openTimes?.end || '18:00').split(':').map(Number);
  
  let currentTime = startHour * 60 + startMin;
  const endTime = endHour * 60 + endMin;
  
  while (currentTime < endTime) {
    const hours = Math.floor(currentTime / 60);
    const minutes = currentTime % 60;
    slots.push(
      hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0')
    );
    currentTime += location.slotDuration || 30;
  }
  
  return slots;
}; 